/** Mirrors backend `DatabricksWorkspaceEntry` in system_settings_models.py. */
export interface DatabricksWorkspaceAuth {
  auth_type: "oauth_m2m" | "pat";
  client_id?: string | null;
  client_secret?: string | null;
  personal_access_token?: string | null;
}

export interface DatabricksWorkspaceEntry {
  url: string;
  auth: DatabricksWorkspaceAuth;
  sql_warehouse_id: string;
  enabled: boolean;
}

export const emptyDatabricksWorkspace = (): DatabricksWorkspaceEntry => ({
  url: "",
  auth: { auth_type: "oauth_m2m" },
  sql_warehouse_id: "",
  enabled: true,
});

/**
 * Picks the entry apart field by field rather than spreading it, so keys from
 * the earlier shape (name, monitor_*) are dropped on load instead of being
 * written straight back on the next Submit.
 */
export const parseWorkspaces = (raw: unknown): DatabricksWorkspaceEntry[] => {
  if (!Array.isArray(raw)) return [];
  return raw.map((raw) => {
    const entry = (raw ?? {}) as Partial<DatabricksWorkspaceEntry>;
    const empty = emptyDatabricksWorkspace();
    return {
      url: entry.url ?? empty.url,
      auth: { ...empty.auth, ...(entry.auth ?? {}) },
      sql_warehouse_id: entry.sql_warehouse_id ?? empty.sql_warehouse_id,
      enabled: entry.enabled ?? empty.enabled,
    };
  });
};
